/**
 * Category template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import ThemeBlogGrid from './partials/ThemeBlogGrid';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Category';

const categoryId = window.page_vars.category_id ? window.page_vars.category_id : null;
const startingPage = window.page_vars.paged ? window.page_vars.paged : 1;

let articlesThemeBlogGrid;
const articlesDom = document.querySelector('[data-articles]');
const articlesThemeBlogGridDom = articlesDom.querySelector('[data-theme-blog-grid]');

let mostPopularThemeBlogGrid;
const mostPopularDom = document.querySelector('[data-most-popular]');
const mostPopularThemeBlogGridDom = mostPopularDom.querySelector('[data-theme-blog-grid]');


// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * Init
 **/
const init = () => {
	Logger.info(`${NAME} > init`);
	initArticlesThemeBlogGrid();
	initMostPopularThemeBlogGrid();
}

/**
 * Init the Theme Blog Grid as infinite scroll
 **/
const initArticlesThemeBlogGrid = () => {
	Logger.info(`${NAME} > initArticlesThemeBlogGrid`);
	articlesThemeBlogGrid = new ThemeBlogGrid(
		articlesThemeBlogGridDom,
		{
			categoryId : categoryId,
			page : startingPage
		}
	);
}

/**
 * Init the Theme Blog Grid as infinite scroll
 **/
const initMostPopularThemeBlogGrid = () => {
	Logger.info(`${NAME} > initMostPopularThemeBlogGrid`);
	mostPopularThemeBlogGrid = new ThemeBlogGrid(
		mostPopularThemeBlogGridDom
	);
}

// Bootstrap global functionality
Global();
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
